import { PayloadAction, CaseReducer } from '@reduxjs/toolkit';
import { ConfiguratorState } from 'models/configurator';
import {
  CompanyGroups,
  CompanyGroupsForTaskAssociation,
  CompanyWorkflow,
  OUserList,
  TaskGroupAssociations,
  WorkflowCompaniesDefinition,
  WorkflowCompaniesDefinitionList,
  WorkflowDefinitionTaskGroupsAssociationsExtended,
  WorkflowGroupList,
  WorkflowTaskList,
} from 'models/response';

const setViewMode: CaseReducer<ConfiguratorState, PayloadAction<boolean>> = (state, { payload }) => {
  state.workflow.viewMode = payload;
};

const setSelectedTab: CaseReducer<ConfiguratorState, PayloadAction<string>> = (state, { payload }) => {
  state.workflow.selectedTabColeCorp = payload;
};

const setSelectedWorkflowCompanies: CaseReducer<ConfiguratorState, PayloadAction<CompanyWorkflow[]>> = (
  state,
  { payload },
) => {
  state.workflow.selectedWorkflowCompanies = payload;
};

const setSelectedDefinitionTaskGroup: CaseReducer<ConfiguratorState, PayloadAction<string>> = (state, { payload }) => {
  state.workflow.selectedDefinitionTaskGroup = payload;
};

const setSelectedCompanyDefinition: CaseReducer<
  ConfiguratorState,
  PayloadAction<WorkflowCompaniesDefinitionList | null>
> = (state, { payload }) => {
  state.workflow.selectedCompanyDefinition = payload;
};

const setCompaniesDefinition: CaseReducer<ConfiguratorState, PayloadAction<WorkflowCompaniesDefinition[]>> = (
  state,
  { payload },
) => {
  state.workflow.companiesDefinition = payload;
};

const setSelectedTask: CaseReducer<ConfiguratorState, PayloadAction<WorkflowTaskList | null>> = (
  state,
  { payload },
) => {
  state.workflow.selectedTask = payload;
};

const setSelectedGroup: CaseReducer<ConfiguratorState, PayloadAction<WorkflowGroupList | null>> = (
  state,
  { payload },
) => {
  state.workflow.selectedGroup = payload;
};

const setListOfDefinitionsForCompanySelected: CaseReducer<
  ConfiguratorState,
  PayloadAction<WorkflowCompaniesDefinitionList[]>
> = (state, { payload }) => {
  state.workflow.listOfDefinitionsForCompanySelected = payload;
};

const setSelectedDefinitionFromCompanySelected: CaseReducer<
  ConfiguratorState,
  PayloadAction<WorkflowCompaniesDefinitionList | null>
> = (state, { payload }) => {
  state.workflow.selectedDefinitionFromCompanySelected = payload;
};

const setEditedRowIdWfDefinition: CaseReducer<ConfiguratorState, PayloadAction<number | null>> = (
  state,
  { payload },
) => {
  state.workflow.editedRowIdWfDefinition = payload;
};

const setIsWfTableEdit: CaseReducer<ConfiguratorState, PayloadAction<boolean>> = (state, { payload }) => {
  state.workflow.isWfTableEdit = payload;
};

const setSelectedDefinitionTaskGroupsAssociations: CaseReducer<
  ConfiguratorState,
  PayloadAction<WorkflowDefinitionTaskGroupsAssociationsExtended | null>
> = (state, { payload }) => {
  state.workflow.selectedDefinitionTaskGroupsAssociations = payload;
};

const setEditedTaskWfRow: CaseReducer<ConfiguratorState, PayloadAction<number | null>> = (state, { payload }) => {
  state.workflow.editedTaskWfRow = payload;
};

const setSelectedWfTask: CaseReducer<ConfiguratorState, PayloadAction<number | null>> = (state, { payload }) => {
  state.workflow.selectedTaskWf = payload;
};

const setEditedRowIdWfGroup: CaseReducer<ConfiguratorState, PayloadAction<number | null>> = (state, { payload }) => {
  state.workflow.editedRowIdWfGroup = payload;
};

const setListOfUserForGroup: CaseReducer<ConfiguratorState, PayloadAction<OUserList[]>> = (state, { payload }) => {
  state.workflow.listOfUserForGroup = payload;
};

const setSelectedGroupFromCompanySelected: CaseReducer<ConfiguratorState, PayloadAction<CompanyGroups | null>> = (
  state,
  { payload },
) => {
  state.workflow.selectedGroupFromCompanySelected = payload;
};
const setSelectedOUserList: CaseReducer<ConfiguratorState, PayloadAction<OUserList | null>> = (state, { payload }) => {
  state.workflow.selectedOUserList = payload;
}

const setSelectedGroupUserAssociation: CaseReducer<ConfiguratorState, PayloadAction<TaskGroupAssociations | null>> = (
  state,
  { payload },
) => {
  state.workflow.selectedGroupUserAssociation = payload;
};

const setEditedRowIdWfAssocations: CaseReducer<ConfiguratorState, PayloadAction<number | null>> = (
  state,
  { payload },
) => {
  state.workflow.editedRowIdWfAssociation = payload;
};

const setListOfGroupsForTaskAssociations: CaseReducer<
  ConfiguratorState,
  PayloadAction<CompanyGroupsForTaskAssociation[]>
> = (state, { payload }) => {
  state.workflow.listOfGroupsForTaskAssociations = payload;
};

const setIsActiveCreateNewAssociation: CaseReducer<ConfiguratorState, PayloadAction<boolean>> = (
  state,
  { payload },
) => {
  state.workflow.isActiveCreateNewAssociation = payload;
};

const setIsActiveEditAssociation: CaseReducer<ConfiguratorState, PayloadAction<boolean>> = (state, { payload }) => {
  state.workflow.isActiveEditAssociation = payload;
};

const setIsActiveAddTaskToAssociation: CaseReducer<ConfiguratorState, PayloadAction<boolean>> = (
  state,
  { payload },
) => {
  state.workflow.isActiveAddTaskToAssociation = payload;
};
const openRowIdAssociationTable: CaseReducer<ConfiguratorState, PayloadAction<number | null>> = (
  state,
  { payload },
) => {
  state.workflow.openRowIdAssociationTable = payload;
};

const setSelectedIdDefFromAssociations: CaseReducer<ConfiguratorState, PayloadAction<number | undefined>> = (
  state,
  { payload },
) => {
  state.workflow.selectedIdDefFromAssociations = payload;
};

const setSelectedIdTaskDefFromAssociations: CaseReducer<ConfiguratorState, PayloadAction<number | undefined>> = (
  state,
  { payload },
) => {
  state.workflow.selectedIdTaskDefFromAssociations = payload;
};

export default {
  setViewMode,
  setSelectedTab,
  setSelectedWorkflowCompanies,
  setSelectedDefinitionTaskGroup,
  setSelectedCompanyDefinition,
  setCompaniesDefinition,
  setSelectedTask,
  setSelectedGroup,
  setListOfDefinitionsForCompanySelected,
  setSelectedDefinitionFromCompanySelected,
  setEditedRowIdWfDefinition,
  setSelectedDefinitionTaskGroupsAssociations,
  setEditedTaskWfRow,
  setSelectedWfTask,
  setIsWfTableEdit,
  setEditedRowIdWfGroup,
  setListOfUserForGroup,
  setSelectedGroupFromCompanySelected,
  setSelectedGroupUserAssociation,
  setEditedRowIdWfAssocations,
  setListOfGroupsForTaskAssociations,
  setIsActiveCreateNewAssociation,
  setIsActiveEditAssociation,
  setIsActiveAddTaskToAssociation,
  openRowIdAssociationTable,
  setSelectedIdDefFromAssociations,
  setSelectedIdTaskDefFromAssociations,
  setSelectedOUserList,
};
